"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  primary: {
    primary100: '#3b73b3',
    primary75: '#6b95c6',
    primary50: '#a0bbda',
    primary25: '#cedcec',
    primary20: '#d8e3f0',
    primary15: '#e4ecf5',
    primary10: '#ebf1f7'
  },
  accent: {
    accent100: '#f5a53d',
    accent75: '#f9be6e',
    accent50: '#fad39e',
    accent25: '#fce9ce',
    accent10: '#fef6eb',
    accent5: '#fefaf5'
  },
  neutral: {
    neutral80: '#333',
    neutral60: '#666',
    neutral45: '#8c8c8c',
    neutral40: '#999',
    neutral25: '#bfbfbf',
    neutral20: '#ccc',
    neutral15: '#d9d9d9',
    neutral10: '#e6e6e6',
    neutral5: '#f2f2f2',
    white100: '#fff'
  },
  variant: {
    primary: '#2a5280',
    success: '#6fba1d',
    accent: '#e69122',
    error: '#b80117'
  },
  status: {
    success100: '#7ed321',
    success75: '#9edf57',
    success50: '#beea8f',
    success25: '#dff5c7',
    success10: '#f2fae8',
    success5: '#f8fdf4',
    alert100: '#f0ce3a',
    alert75: '#f8e36d',
    alert50: '#faeb9e',
    alert10: '#fefaeb',
    alert5: '#fefdf5',
    error100: '#d0021b',
    error75: '#dd4455',
    error50: '#e8818d',
    error10: '#fae5e8'
  }
};